"use client";

import * as React from 'react';
const DropdownContext = /*#__PURE__*/React.createContext({});
DropdownContext.displayName = 'DropdownContext';
export default DropdownContext;